'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import { getBlogExcerpt, type BlogCardData } from '@/utils/blog-card-data';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export type BlogCardProps = {
  blog: Blog | BlogCardData;
};

export function BlogCard({ blog }: BlogCardProps) {
  const { t } = useTranslations();
  const excerpt = 'excerpt' in blog ? blog.excerpt : getBlogExcerpt(blog.content);

  return (
    <Link
      href={ROUTES.BLOG_DETAIL({ slug: blog.slug })}
      prefetchOnHover
      className="col-span-1 flex w-full flex-col items-start justify-start gap-6"
    >
      <div className="relative h-[270px] w-full overflow-hidden rounded-[20px] p-3">
        <Image
          src={blog?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(blog?.image, blog?.name)}
          fill
          sizes="(min-width: 1280px) 410px, (min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          loading="lazy"
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
        />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-3">
        <Heading
          tag="h3"
          title={blog.name}
          className={{ container: 'h-16', title: 'h4 line-clamp-2' }}
        />
        <Paragraph
          className="line-clamp-2 max-h-8 min-h-8 w-full sm:max-h-9 sm:min-h-9"
          color="neutral"
          size="sm"
        >
          {excerpt}
        </Paragraph>
      </div>
      <span className="inline-flex h-10 items-center rounded-[20px] bg-white px-4 text-sm font-medium">
        {t('text792')}
      </span>
    </Link>
  );
}
